import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import Pagination from '@material-ui/lab/Pagination';
import { colors } from '../constants/styleConstants';

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    justifyContent: 'center',
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
    width: '100%',
    '& .MuiPaginationItem-textPrimary.Mui-selected': {
      background: 'transparent',
      border: `2px solid ${colors.primary}`,
      color: colors.textColor,
    },
  },
}));

const FbPagination = ({ filters, fetchFunction, onPageChange }) => {
  const classes = useStyles();
  const count = Math.ceil(filters.total / filters.limit);

  const handleChange = (event, value) => {
    fetchFunction({ limit: filters.limit, page: value });
    onPageChange();
  };

  const isEmpty = !filters.total;

  if (isEmpty) {
    return null;
  }

  return (
    <div className={classes.root}>
      <Pagination
        count={count}
        page={filters.page}
        color="primary"
        onChange={handleChange}
        showFirstButton
        showLastButton
      />
    </div>
  );
};

FbPagination.propTypes = {
  fetchFunction: PropTypes.func,
  onPageChange: PropTypes.func,
  filters: PropTypes.shape({
    limit: PropTypes.number,
    page: PropTypes.number,
    total: PropTypes.number,
  }),
};

FbPagination.defaultProps = {
  fetchFunction: () => {},
  onPageChange: () => {},
  filters: {
    limit: 20,
    page: 1,
    total: 0,
  },
};

export default FbPagination;
